import React from 'react';
import { useModal } from '@context/ModalContext';

const ClaimModal: React.FC = () => {
  const { tekstClaimModal, openClaimModal } = useModal();

  return (
    <div className={`modalClaim ${openClaimModal ? 'open' : ''}`}>
      <div>
        <img src="img/store.png" alt="" width={44} />
      </div>
      <span>{tekstClaimModal}</span>
    </div>
  );
};

export default ClaimModal;
